// tslint:disable:no-any (autogenerated)
import BaseRequest from '../../../../base/base-request';

class RtkUserAccountRequest extends BaseRequest {
    // tslint:disable-next-line:typedef (autogenerated)
    private sources = {
        getUserData: '/user/get',
        setUserData: '/user/set',
        resetPassword: '/security/ajaxChangePassword'
    };

    public async getUserData(): Promise<IUserData> {
        return this.request<IUserData>(this.sources.getUserData);
    }

    public async setUserData(userData: IUserData): Promise<any> {
        return this.request<any>(this.sources.setUserData, userData);
    }

    public async resetPassword(data: IResetPasswordData): Promise<any> {
        // tslint:disable-next-line:no-return-await (autogenerated)
        return await this.request<any>(this.sources.resetPassword, data);
    }
}

const rtkUserAccountRequest = new RtkUserAccountRequest();
// tslint:disable-next-line:no-default-export (autogenerated)
export default rtkUserAccountRequest;
